// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fundo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css 
.App {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
/*  height: 100%;
  padding-top: 60px;
  margin-top: 40px; /* Altura da sua navbar 
  box-sizing: border-box;
  min-height: calc(100vh - 60px); /* Desconta a altura da navbar 
}
*/
.App {
  position: relative;
  min-height: calc(100vh - 60px); /* ajusta conforme altura do menu */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;         /* cobre toda a área */
  background-position: center;    /* centraliza */
  background-repeat: no-repeat;   /* sem repetição */
  padding-top: 80px;              /* espaço abaixo do menu */
}

body {
  margin: 0;
  background-color: #f8f9fc;
}

.diagram-container {
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 1340px;
  margin: 100px auto 20px auto; /* 100px garante espaço total do menu fixo */
  padding: 0 10px; /* opcional, dá um pequeno respiro nas laterais */
}

.diagram {
  display: block;
  margin: 0 auto;
  max-width: 100%;
  height: auto;
}


.tooltip {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 0.85rem;
  pointer-events: none;
  z-index: 1000;
  white-space: nowrap;
}



/* Mantenha seus estilos originais dos sensores */
.sensor-value, .sensor-disable {
  font-size: 9px;
  pointer-events: none;
  paint-order: stroke;
  /*stroke: white;*/
  stroke-width: 5px;
  font-weight: bold;
}

.sensor-value {
  fill: rgb(3, 3, 14);
  pointer-events: all; /* <- Permite eventos do mouse */
}

.sensor-disable {
  fill: black;
  pointer-events: none; /* <- Ainda desativa para sensores inativos, se quiser */
}

.sensor-value:hover {
  fill: red;
  cursor: pointer;
}

`, "",{"version":3,"sources":["webpack://./src/components/home/App.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;CAYC;AACD;EACE,kBAAkB;EAClB,8BAA8B,EAAE,mCAAmC;EACnE,yDAAkC;EAClC,sBAAsB,UAAU,sBAAsB;EACtD,2BAA2B,KAAK,eAAe;EAC/C,4BAA4B,IAAI,kBAAkB;EAClD,iBAAiB,eAAe,0BAA0B;AAC5D;;AAEA;EACE,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,4BAA4B,EAAE,4CAA4C;EAC1E,eAAe,EAAE,iDAAiD;AACpE;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,YAAY;AACd;;;AAGA;EACE,eAAe;EACf,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;AACrB;;;;AAIA,iDAAiD;AACjD;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB,EAAE,gCAAgC;AACvD;;AAEA;EACE,WAAW;EACX,oBAAoB,EAAE,wDAAwD;AAChF;;AAEA;EACE,SAAS;EACT,eAAe;AACjB","sourcesContent":["/* App.css \n.App {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n/*  height: 100%;\n  padding-top: 60px;\n  margin-top: 40px; /* Altura da sua navbar \n  box-sizing: border-box;\n  min-height: calc(100vh - 60px); /* Desconta a altura da navbar \n}\n*/\n.App {\n  position: relative;\n  min-height: calc(100vh - 60px); /* ajusta conforme altura do menu */\n  background-image: url('fundo.png');\n  background-size: cover;         /* cobre toda a área */\n  background-position: center;    /* centraliza */\n  background-repeat: no-repeat;   /* sem repetição */\n  padding-top: 80px;              /* espaço abaixo do menu */\n}\n\nbody {\n  margin: 0;\n  background-color: #f8f9fc;\n}\n\n.diagram-container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  max-width: 1340px;\n  margin: 100px auto 20px auto; /* 100px garante espaço total do menu fixo */\n  padding: 0 10px; /* opcional, dá um pequeno respiro nas laterais */\n}\n\n.diagram {\n  display: block;\n  margin: 0 auto;\n  max-width: 100%;\n  height: auto;\n}\n\n\n.tooltip {\n  position: fixed;\n  background-color: rgba(0, 0, 0, 0.75);\n  color: white;\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  pointer-events: none;\n  z-index: 1000;\n  white-space: nowrap;\n}\n\n\n\n/* Mantenha seus estilos originais dos sensores */\n.sensor-value, .sensor-disable {\n  font-size: 9px;\n  pointer-events: none;\n  paint-order: stroke;\n  /*stroke: white;*/\n  stroke-width: 5px;\n  font-weight: bold;\n}\n\n.sensor-value {\n  fill: rgb(3, 3, 14);\n  pointer-events: all; /* <- Permite eventos do mouse */\n}\n\n.sensor-disable {\n  fill: black;\n  pointer-events: none; /* <- Ainda desativa para sensores inativos, se quiser */\n}\n\n.sensor-value:hover {\n  fill: red;\n  cursor: pointer;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
